<!-- eslint-disable no-unused-expressions -->
<script>
    import ApiModeVuetable from '@/src/components/ApiModeVuetable.vue'
    import SchedulesService from '@src/services/SchedulesService.js'
    import Layout from '@layouts/main'
    import Breadcrumb from '@/src/components/Breadcrumb.vue'
    import PageHeader from '@components/PageHeader'
    import pagination from '@src/mixins/pagination'
    import swalFeedback from '@src/mixins/swalFeedback'
    import vuetableFormatters from '@src/mixins/vuetableFormatters'
    import filterVuetable from '@src/mixins/filterVuetable'
    import FilterBar from '@src/components/FilterBar'
    import AddButton from '@/src/components/AddLabelButton.vue'
    import ExportButton from '@/src/components/ExportButton.vue'
    import FilterLabelButton from '@/src/components/FilterLabelButton.vue'
    import MoreTableButton from '@/src/components/MoreTableButton.vue'
    import DeleteTableButton from '@/src/components/DeleteTableButton.vue'
    import SchedulesModal from '@src/router/views/schedules/schedulesModal.vue'
    import SchedulesFilterModal from '@src/router/views/schedules/schedulesFilterModal.vue'
    import { SCHEDULE_ACTION_VALUES } from '@src/constants/scheduleActions'
    import { debounce } from 'lodash'
    import moment from 'moment'

    const i18nCommon = 'COMMON'
    const i18nKey = 'SCHEDULES'

    export default {
        components: {
            ApiModeVuetable,
            Layout,
            Breadcrumb,
            PageHeader,
            FilterBar,
            AddButton,
            ExportButton,
            FilterLabelButton,
            MoreTableButton,
            DeleteTableButton,
            SchedulesModal,
            SchedulesFilterModal,
        },
        mixins: [
            swalFeedback,
            pagination,
            vuetableFormatters,
            filterVuetable,
        ],
        data() {
            return {
                sortOrder: [
                    {
                        field: 'date',
                        direction: 'desc',
                    },
                ],
                i18nCommon,
                i18nKey,
                data: [],
                perPage: 10,
                fields: [
                    {
                        name: 'description',
                        title: this.getI18n(i18nKey, 'FIELDS.description'),
                        sortField: 'description',
                    },
                    {
                        name: 'action',
                        title: this.getI18n(i18nKey, 'FIELDS.action'),
                        sortField: 'action',
                        formatter: (value) => {
                            if (value && SCHEDULE_ACTION_VALUES.includes(value)) {
                                return this.getI18n(i18nKey, `ACTIONS.${value}`)
                            }
                            return value || ''
                        },
                    },
                    {
                        name: 'date',
                        title: this.getI18n(i18nKey, 'FIELDS.date'),
                        sortField: 'date',
                        formatter: (value) => {
                            if (value) {
                                return moment(value).format('DD/MM/YYYY')
                            }
                            return ''
                        },
                    },
                    {
                        name: 'created_by',
                        title: this.getI18n(i18nKey, 'FIELDS.created_by'),
                        sortField: 'created_by',
                    },
                    {
                        name: 'created_at',
                        title: this.getI18n(i18nKey, 'FIELDS.created_at'),
                        sortField: 'created_at',
                    },
                    {
                        name: 'updated_by',
                        title: this.getI18n(i18nKey, 'FIELDS.updated_by') || 'Alterado por',
                        sortField: 'updated_by',
                    },
                    {
                        name: 'actions',
                        title: '',
                    },
                ],
                css: {},
                filterText: '',
                additionalParameters: {},
                filters: {},
                busy: false,
                scheduleModalIsEdit: true,
            }
        },
        computed: {
            items() {
                return [
                    {
                        text: 'Home',
                        href: '/',
                    },
                    {
                        text: this.getI18nModified({
                            prefix: 'WORKSCHEDULES',
                            suffix: 'TITLES.work_schedule',
                            modifier: 2,
                        }),
                        active: true,
                    },
                    {
                        text: this.getI18nModified({
                            prefix: i18nKey,
                            suffix: 'TITLES.schedule',
                            modifier: 2,
                        }),
                        active: true,
                    },
                ]
            },
            i18nNewSchedule() {
                return this.getI18n(i18nKey, 'BUTTONS.new_schedule')
            },
        },
        watch: {
            filterText: debounce(function (searchText) {
                this.additionalParameters = {
                    search: '',
                }

                if (searchText && searchText.length > 0) {
                    this.additionalParameters.search = `description:${searchText}`
                }

                this.refreshTable()
            }, 1000),
        },
        methods: {
            createAdditionalParameters() {
                const searchParts = []

                // Filtro por descrição
                if (this.filters.description) {
                    searchParts.push(`description:${this.filters.description}`)
                }

                // Filtro por ação
                if (this.filters.action && typeof this.filters.action === 'object' && this.filters.action.value) {
                    searchParts.push(`action:${this.filters.action.value}`)
                } else if (this.filters.action) {
                    searchParts.push(`action:${this.filters.action}`)
                }

                // Filtro por data
                if (this.filters.date) {
                    const dateStr = moment(this.filters.date).format('YYYY-MM-DD')
                    searchParts.push(`date:${dateStr}`)
                }

                // Filtro por tipo de filtro
                if (this.filters.filter_type && typeof this.filters.filter_type === 'object' && this.filters.filter_type.value) {
                    searchParts.push(`filter_type:${this.filters.filter_type.value}`)
                } else if (this.filters.filter_type) {
                    searchParts.push(`filter_type:${this.filters.filter_type}`)
                }

                const search = searchParts.join(';')

                return this.formatParameters({
                    search: search || '',
                    searchJoin: searchParts.length > 1 ? 'and' : '',
                })
            },

            fetch(url, params) {
                return SchedulesService.fetchVuetable(url, params)
            },

            i18nSchedule(modifier) {
                return this.getI18nModified({
                    prefix: i18nKey,
                    suffix: 'TITLES.schedule',
                    modifier: modifier,
                })
            },

            openModalToCreate() {
                this.scheduleModalIsEdit = true
                this.$nextTick(() => {
                    this.$refs.schedulesModal.replaceModalData({
                        id: 0,
                        date: null,
                        description: '',
                        action: '',
                        filter_type: '',
                        filter_values: [],
                        block_app: true,
                    })
                    this.$refs.schedulesModal.showModal()
                })
            },

            openModalToEdit(schedule) {
                const dateStr = schedule.date ? (typeof schedule.date === 'string' ? schedule.date.slice(0, 10) : moment(schedule.date).format('YYYY-MM-DD')) : null
                const today = moment().format('YYYY-MM-DD')
                const isPastOrToday = dateStr && dateStr <= today
                this.scheduleModalIsEdit = !isPastOrToday
                this.$nextTick(() => {
                    this.$refs.schedulesModal.replaceModalData({
                        id: schedule.id,
                        date: schedule.date ? moment(schedule.date, 'YYYY-MM-DD').toDate() : null,
                        description: schedule.description || '',
                        action: schedule.action || '',
                        filter_type: schedule.filter_type || '',
                        filter_values: schedule.filter_values || [],
                        block_app: schedule.block_app !== false,
                        created_by: schedule.created_by,
                        created_at: schedule.created_at,
                        updated_by: schedule.updated_by,
                        updated_at: schedule.updated_at,
                    })
                    this.$refs.schedulesModal.showModal()
                })
            },

            canCancelSchedule(schedule) {
                const dateStr = schedule.date ? (typeof schedule.date === 'string' ? schedule.date.slice(0, 10) : moment(schedule.date).format('YYYY-MM-DD')) : null
                if (!dateStr) return false
                const today = moment().format('YYYY-MM-DD')
                return dateStr > today
            },

            handleCancelClick(schedule) {
                if (!this.canCancelSchedule(schedule)) return
                this.handleDeleteSchedule(schedule)
            },

            async handleDeleteSchedule(schedule) {
                if (!this.canCancelSchedule(schedule)) return
                const msg = this.getI18n(i18nKey, 'MESSAGES.confirm_cancel') || 'Deseja realmente cancelar este agendamento?'
                if (!window.confirm(msg)) return
                try {
                    await SchedulesService.delete(schedule.id)
                    this.positiveFeedback(this.getI18n(i18nKey, 'TITLES.schedule'), 'deleted')
                    this.refreshTable()
                } catch (err) {
                    const message = err?.response?.data?.message || this.getI18n('RESPONSES', 'something_wrong')
                    this.negativeFeedback(this.getI18n('RESPONSES', 'something_wrong'), message)
                }
            },

            filter(appliedFilters) {
                this.filters = appliedFilters
                this.additionalParameters = this.createAdditionalParameters()
                this.refreshTable()
            },
            showFilterModal() {
                this.$nextTick(() =>
                    this.$refs.schedulesFilterModal.showModal(this.filters)
                )
            },

            reloadTable() {
                this.$refs.vuetable.reload()
            },

            refreshTable() {
                this.$refs.vuetable.refresh()
            },
        },
    }
</script>

<template>
    <Layout>
        <div class="col-12">
            <Breadcrumb :items="items" />
            <div class="row mt-3 mb-3">
                <div class="col-sm-6 form-inline">
                    <filter-bar v-model="filterText" />
                    <filter-label-button @onClick="showFilterModal" />
                </div>
                <div class="col-sm-6">
                    <div class="text-sm-right">
                        <export-button
                            v-if="$can('CREATE', 'EXPORTJOB')"
                            type="schedule"
                            :create-parameters="createAdditionalParameters"
                            :vuetable-ref="$refs.vuetable"
                        />
                        <add-button
                            :title="i18nNewSchedule"
                            @onClick="openModalToCreate"
                        />
                    </div>
                </div>
            </div>
            <div class="card card-pdv">
                <b-row>
                    <div class="col-sm-12">
                        <PageHeader :title="i18nSchedule(2)" />
                    </div>
                    <div class="card-body">
                        <api-mode-vuetable
                            ref="vuetable"
                            :fetch-data="fetch"
                            :fields="fields"
                            :per-page="perPage"
                            :display-selection-records-per-page="true"
                            :additional-parameters="additionalParameters"
                            :sort-order="sortOrder">
                            <template slot="actions" slot-scope="props">
                                <div class="table-button-container d-flex align-items-center justify-content-end" style="min-width: 5rem;">
                                    <delete-table-button
                                        :title="getI18n(i18nKey, 'BUTTONS.cancel_schedule') || 'Cancelar'"
                                        :disabled="!canCancelSchedule(props.rowData)"
                                        class="mr-1"
                                        @onClick="canCancelSchedule(props.rowData) && handleDeleteSchedule(props.rowData)"
                                    />
                                    <more-table-button @onClick="openModalToEdit(props.rowData)" />
                                </div>
                            </template>
                        </api-mode-vuetable>
                    </div>
                </b-row>
            </div>
        </div>
        <schedules-modal
            ref="schedulesModal"
            :modal-is-edit="scheduleModalIsEdit"
            :modal="{}"
            @refresh="refreshTable"
        />
        <schedules-filter-modal
            ref="schedulesFilterModal"
            :handle-submit="filter"
        />
    </Layout>
</template>

